export enum AccountStatus {
  Created = 'created',
  Active = 'active',
  Terminated = 'terminated',
  Suspended = 'suspended',
  Trial = 'trial'
}
